export default [
    {
        path: "/",
        component: () => import("../views/auth"),
        children: [
            {
                path: "login",
                component: () => import("../views/auth/Login"),
            },
            {
                path: "register",
                component: () => import("../views/auth/Register"),
            },
            {
                path: "forgot-password",
                component: () => import("../views/auth/ForgotPassword"),
            },
            {
                path: "reset-password",
                component: () => import("../views/auth/ResetPassword"),
            },

        ]
    },
]
